import React from "react";
import { useTranslation } from "react-i18next";
import { HugeiconsIcon } from "@hugeicons/react";
import {
    LegalDocument01Icon,
    CancelCircleIcon,
    Door01Icon,
    CopyrightIcon,
    Shield01Icon,
    JusticeScale01Icon,
    InformationCircleIcon,
    Cancel01Icon,
} from "@hugeicons/core-free-icons";
import "./terms.scss";
import { Col, Row } from "react-bootstrap";
import { TermsBgSVG } from "@/Component/TermsBgSVG";

export const Terms = () => {
    const { t } = useTranslation();

    return (
        <div className="terms-page" style={{ paddingBottom: "70px" }}>
            <div className="hero">
                <div className="hero-bg" />
                <TermsBgSVG />

                <div className="hero-content">
                    <div className="hero-icon-wrap">
                        <HugeiconsIcon icon={LegalDocument01Icon} size={32} className="hero-icon-inner" />
                    </div>
                    <h1>{t("TERMS_HERO_TITLE")}</h1>
                    <p>{t("TERMS_HERO_SUBTITLE")}</p>
                </div>
                <div className="hero-arch" />
            </div>

            <div className="container-fluid ">

                <Row>
                    <Col xs={12} lg={4} style={{ marginBottom: "20px" }}>
                        <div className="toc-wrap">
                            <div className="toc">
                                <div className="toc-title">{t("TERMS_TOC_TITLE")}</div>
                                <a href="#usage">
                                    <HugeiconsIcon icon={LegalDocument01Icon} size={18} />
                                    {t("TERMS_TOC_USAGE")}
                                </a>
                                <a href="#restrictions">
                                    <HugeiconsIcon icon={CancelCircleIcon} size={18} />
                                    {t("TERMS_TOC_RESTRICTIONS")}
                                </a>
                                <a href="#termination">
                                    <HugeiconsIcon icon={Door01Icon} size={18} />
                                    {t("TERMS_TOC_TERMINATION")}
                                </a>
                                <a href="#ip">
                                    <HugeiconsIcon icon={CopyrightIcon} size={18} />
                                    {t("TERMS_TOC_IP")}
                                </a>
                                <a href="#virus">
                                    <HugeiconsIcon icon={Shield01Icon} size={18} />
                                    {t("TERMS_TOC_VIRUS")}
                                </a>
                                <a href="#jurisdiction">
                                    <HugeiconsIcon icon={JusticeScale01Icon} size={18} />
                                    {t("TERMS_TOC_JURISDICTION")}
                                </a>
                                <a href="#liability">
                                    <HugeiconsIcon icon={InformationCircleIcon} size={18} />
                                    {t("TERMS_TOC_LIABILITY")}
                                </a>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} lg={8}>
                        <main style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                            <div className="section-card" id="usage">
                                <div className="section-header">
                                    <div className="section-icon">
                                        <HugeiconsIcon icon={LegalDocument01Icon} size={22} />
                                    </div>
                                    <h2>{t("TERMS_SECTION_USAGE_TITLE")}</h2>
                                </div>
                                <div className="section-body">
                                    <p>{t("TERMS_SECTION_USAGE_P1")}</p>
                                    <p>{t("TERMS_SECTION_USAGE_P2")}</p>
                                </div>
                            </div>

                            <div className="section-card" id="restrictions">
                                <div className="section-header">
                                    <div className="section-icon">
                                        <HugeiconsIcon icon={CancelCircleIcon} size={22} />
                                    </div>
                                    <h2>{t("TERMS_SECTION_RESTRICTIONS_TITLE")}</h2>
                                </div>
                                <div className="section-body">
                                    <p>{t("TERMS_SECTION_RESTRICTIONS_INTRO")}</p>
                                    <ul className="restriction-list">
                                        <li>
                                            <span className="r-icon">
                                                <HugeiconsIcon icon={Cancel01Icon} size={14} />
                                            </span>
                                            {t("TERMS_RESTRICTION_1")}
                                        </li>
                                        <li>
                                            <span className="r-icon">
                                                <HugeiconsIcon icon={Cancel01Icon} size={14} />
                                            </span>
                                            {t("TERMS_RESTRICTION_2")}
                                        </li>
                                        <li>
                                            <span className="r-icon">
                                                <HugeiconsIcon icon={Cancel01Icon} size={14} />
                                            </span>
                                            {t("TERMS_RESTRICTION_3")}
                                        </li>
                                        <li>
                                            <span className="r-icon">
                                                <HugeiconsIcon icon={Cancel01Icon} size={14} />
                                            </span>
                                            {t("TERMS_RESTRICTION_4")}
                                        </li>
                                        <li>
                                            <span className="r-icon">
                                                <HugeiconsIcon icon={Cancel01Icon} size={14} />
                                            </span>
                                            {t("TERMS_RESTRICTION_5")}
                                        </li>
                                        <li>
                                            <span className="r-icon">
                                                <HugeiconsIcon icon={Cancel01Icon} size={14} />
                                            </span>
                                            {t("TERMS_RESTRICTION_6")}
                                        </li>
                                        <li>
                                            <span className="r-icon">
                                                <HugeiconsIcon icon={Cancel01Icon} size={14} />
                                            </span>
                                            {t("TERMS_RESTRICTION_7")}
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="section-card" id="termination">
                                <div className="section-header">
                                    <div className="section-icon">
                                        <HugeiconsIcon icon={Door01Icon} size={22} />
                                    </div>
                                    <h2>{t("TERMS_SECTION_TERMINATION_TITLE")}</h2>
                                </div>
                                <div className="section-body">
                                    <p>{t("TERMS_SECTION_TERMINATION_P1")}</p>
                                    <p>{t("TERMS_SECTION_TERMINATION_P2")}</p>
                                </div>
                            </div>

                            <div className="section-card" id="ip">
                                <div className="section-header">
                                    <div className="section-icon">
                                        <HugeiconsIcon icon={CopyrightIcon} size={22} />
                                    </div>
                                    <h2>{t("TERMS_SECTION_IP_TITLE")}</h2>
                                </div>
                                <div className="section-body">
                                    <p>{t("TERMS_SECTION_IP_P1")}</p>
                                    <p>{t("TERMS_SECTION_IP_P2")}</p>
                                    <div className="ownership-note">
                                        <span className="note-icon">
                                            <HugeiconsIcon icon={InformationCircleIcon} size={20} />
                                        </span>
                                        <span>{t("TERMS_SECTION_IP_NOTE")}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="section-card" id="virus">
                                <div className="section-header">
                                    <div className="section-icon">
                                        <HugeiconsIcon icon={Shield01Icon} size={22} />
                                    </div>
                                    <h2>{t("TERMS_SECTION_VIRUS_TITLE")}</h2>
                                </div>
                                <div className="section-body">
                                    <p>{t("TERMS_SECTION_VIRUS_P1")}</p>
                                    <p>{t("TERMS_SECTION_VIRUS_P2")}</p>
                                </div>
                            </div>

                            <div className="section-card" id="jurisdiction">
                                <div className="section-header">
                                    <div className="section-icon">
                                        <HugeiconsIcon icon={JusticeScale01Icon} size={22} />
                                    </div>
                                    <h2>{t("TERMS_SECTION_JURISDICTION_TITLE")}</h2>
                                </div>
                                <div className="section-body">
                                    <p>{t("TERMS_SECTION_JURISDICTION_P1")}</p>
                                </div>
                            </div>

                            <div className="section-card" id="liability">
                                <div className="section-header">
                                    <div className="section-icon">
                                        <HugeiconsIcon icon={InformationCircleIcon} size={22} />
                                    </div>
                                    <h2>{t("TERMS_SECTION_LIABILITY_TITLE")}</h2>
                                </div>
                                <div className="section-body">
                                    <p>{t("TERMS_SECTION_LIABILITY_P1")}</p>
                                    <p>{t("TERMS_SECTION_LIABILITY_P2")}</p>
                                    <p>{t("TERMS_SECTION_LIABILITY_P3")}</p>
                                </div>
                            </div>
                        </main>

                    </Col>
                </Row>

            </div>

        </div>
    );
};
